import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@mui/material";
import { mixpanel } from "common/analytics";
import { useTranslation } from "common/locales";
import { useHistory } from "react-router-dom";

interface FileShareNotificationData {
  fileName: string;
  uploaderName: string;
}

interface PushNotificationModalProps {
  open: boolean;
  onClose: () => void;
  notificationData: FileShareNotificationData | null;
}

export default function PushNotificationModal({
  open,
  onClose,
  notificationData,
}: PushNotificationModalProps) {
  const history = useHistory();
  const { t } = useTranslation();

  const handleNavigateToFileManagement = () => {
    mixpanel.track(
      "Push notification file share - navigated to file management"
    );
    history.push("/file-management-overview?fromPushNotification=true");
    onClose();
  };

  const handleDismiss = () => {
    mixpanel.track("Push notification file share - dismissed");
    onClose();
  };

  if (!notificationData) return null;

  return (
    <Dialog
      open={open}
      onClose={handleDismiss}
      aria-labelledby="push-notification-title"
      aria-describedby="push-notification-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="push-notification-title">
        <Typography variant="h6" component="div">
          {t("pushNotification.fileShare.title")}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ py: 1 }}>
          <DialogContentText id="push-notification-description">
            {t("pushNotification.fileShare.message", {
              uploaderName: notificationData.uploaderName,
              fileName: notificationData.fileName,
            })}
          </DialogContentText>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleDismiss} color="secondary" variant="text">
          {t("pushNotification.fileShare.dismiss")}
        </Button>
        <Button
          onClick={handleNavigateToFileManagement}
          color="primary"
          variant="contained"
          autoFocus
        >
          {t("pushNotification.fileShare.viewFiles")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export type { FileShareNotificationData };
